export default {
	'payment-restrictions-only': 'Sadece ödeme Kayıtları',
	'the-total-number': 'Sayı Toplam',
	'non-posted-bonds-count': 'Devredilemeyen tahviller sayısı',
	type: 'Türü',
	all: 'Tümü',
	posted: 'Devredilen',
	'non-posted': 'Devredilemeyen',
	tabs: {
		all: 'Tümü',
		'cashboxes-journals': 'Kasaların yövmiyesi',
		'journals-linking-invoices': 'Faturaları bağlayan yövmiyeler',
		'journals-associated-with-the-closing-of-funds': 'Kasalar kapanışıyla ilgili yövmiyeler'
	}
}